__webpack_require__.p = "/RGPD/";